var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',[_c('v-slide-group',{attrs:{"show-arrows":""}},_vm._l((_vm.couponArray),function(item,i){return _c('v-slide-item',{key:i,class:_vm.$vuetify.breakpoint.smAndUp?'mx-2':'mx-4'},[_c('store-coupon-card',{attrs:{"coupon":item}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }